import UserList from "./views/user-list";
import Dp3List from "./views/dp3-list";
import LiburList from "./views/libur-list";
import CutiList from "./views/cuti-list";
import CutiSettingList from "./views/cuti-setting-list";
import ActivityLog from "./views/activity-log";
import api from "@/api";
import CekGaji from "./views/cek-gaji";
import DukPrint from "./views/duk-print";
import DukList from "./views/duk-list";
import SkemaGajiList from "./views/skema-gaji-list";
import DiklatPrintPageBreak from "./views/diklat-print-page-break";
import GenerateDocument from "./views/generate-document";
import HtmlToWordPractice from "./views/html-to-word-practice";
import DiklatPrint from "./views/diklat-print";
import DiklatList from "./views/diklat-list";
import DewasArsip from "./views/dewas-arsip";
import DewasAdd from "./views/dewas-add";
import DewasList from "./views/dewas-list";
import DewasDetail from "./views/dewas-detail";
import PenghargaanList from "./views/penghargaan-list";
import PeringatanList from "./views/peringatan-list";
// import AbsenListInput from './views/absen-list-input';
import GajiHistoryCustom from "./views/gaji-history-custom";
import GajiRekapPrint from "./views/GajiRekapPrint";
import GajiPrint from "./views/gaji-print";
import GajiListCustom from "./views/gaji-list-custom";
import PengajuanList from "./views/pengajuan-list";
import ArsipList from "./views/arsip-list";
import BelajarTagbox from "./views/belajar_tagbox";
import PegawaiDetailCustom from "./views/pegawai-detail-custom";
import AbsenInputCustom from "./views/absen-input-custom";
import PensiunListCustom from "./views/pensiun-list-custom";
import KgbPrediksiListCustom from "./views/kgb-prediksi-list-custom";
import NaikPangkatPrediksiListCustom from "./views/naik-pangkat-prediksi-list-custom";
import PendidikanListCustom from "./views/pendidikan-list-custom";
import TransportListCustom from "./views/transport-list-custom";
import PekerjaanListCustom from "./views/pekerjaan-list-custom";
import KgbListCustom from "./views/kgb-list-custom";
import NaikPangkatListCustom from "./views/naik-pangkat-list-custom";
import PegawaiListCustom from "./views/pegawai-list-custom";
import GajiListGabung from "./views/gaji-list-gabung";
import AbsenListGabung from "./views/absen-list-gabung";
// import AbsenListCustomstore from './views/absen-list-customstore';
import AbsenListCustom from "./views/absen-list-custom";

import SimpegDashboardFilter from "./views/simpeg-dashboard-filter";
import AbsenBulanInputFinalRemote from "./views/absen-bulan-input-final-remote";
import AbsenListRemote from "./views/absen-list-remote";
import PendidikanListRemote from "./views/pendidikan-list-remote";
import TransportListRemote from "./views/transport-list-remote";
import ListPltRemote from "./views/list-plt-remote";
import PekerjaanListRemote from "./views/pekerjaan-list-remote";
import SimpegPensiunListRemote from "./views/simpeg-pensiun-list-remote";
import SimpegKgbPrediksiListRemote from "./views/simpeg-kgb-prediksi-list-remote";
import SimpegNaikpangkatPrediksiListRemote from "./views/simpeg-naikpangkat-prediksi-list-remote";
import SimpegKgbListRemote from "./views/simpeg-kgb-list-remote";
import SimpegNaikPangkatListRemote from "./views/simpeg-naik-pangkat-list-remote";
// import SimpegNaikPangkatRemote from './views/simpeg-naik-pangkat-remote';
import SimpegPegawaiListRemote from "./views/simpeg-pegawai-list-remote";
import GajiPeriodeVirtualScroll from "./views/gaji-periode-virtual-scroll";
import AbsenListVirtualScroll from "./views/absen-list-virtual-scroll";
import PendidikanListVirtualScroll from "./views/pendidikan-list-virtual-scroll";
import TransportListVirtualScroll from "./views/transport-list-virtual-scroll";
import ListPltVirtualScroll from "./views/list-plt-virtual-scroll";
import PekerjaanListVirtualScroll from "./views/pekerjaan-list-virtual-scroll";
import SimpegPensiunListVirtualScroll from "./views/simpeg-pensiun-list-virtual-scroll";
import SimpegNaikpangkatPrediksiListVirtualScroll from "./views/simpeg-naikpangkat-prediksi-list-virtual-scroll";
import SimpegKgbPrediksiListVirtualScroll from "./views/simpeg-kgb-prediksi-list-virtual-scroll";
import SimpegKgbListVirtualScroll from "./views/simpeg-kgb-list-virtual-scroll";
import SimpegNaikPangkatListVirtualScroll from "./views/simpeg-naik-pangkat-list-virtual-scroll";
import SimpegPegawaiListVirtualScroll from "./views/simpeg-pegawai-list-virtual-scroll";
import PekerjaanList from "./views/pekerjaan-list";
import PendidikanList from "./views/pendidikan-list";
import TransportList from "./views/transport-list";
import GajiRekapV2 from "./views/gaji-rekap-v2";
import GajiHistory from "./views/gaji-history";
import GajiPeriode from "./views/gaji-periode";
import CheckTglPegawaiImport from "./views/check-tgl-pegawai-import";
import SimpegNaikpangkatPrediksiList from "./views/simpeg-naikpangkat-prediksi-list";
import PracticeLoadingScreen from "./views/practice-loading-screen";
import PracticeSplineChart from "./views/practice-spline-chart";
import ProyeksiPractice from "./views/proyeksi_practice";
import SimpegKgbPrediksiList from "./views/simpeg-kgb-prediksi-list";
import PracticeDialog from "./views/practice-dialog";
import PracticeParentChildTemplate from "./views/practice-parent-child-template";
import PracticeChartDoughnut from "./views/practice-chart-doughnut";
import DxlookupValueChangedDatagrid from "./views/dxlookup-value-changed-datagrid";
import DxlookupValueChanged from "./views/dxlookup-value-changed";
// import SimpegPegawaiDetailBackup2 from './views/simpeg-pegawai-detail-backup2';
import SimpegPegawaiAddBackup from "./views/simpeg-pegawai-add-backup";
import SimpegPensiunList from "./views/simpeg-pensiun-list";
import PrintGajiPlt from "./views/print-gaji-plt";
import PrintGajiTetapUnitOK from "./views/print-gaji-tetap-unit-OK";
import PrintGajiDireksiTetapHonorKontrakOK from "./views/print-gaji-direksi-tetap-honor-kontrak-OK";
import PrintGajiTetapOK from "./views/print-gaji-tetap-OK";
import PringGajiQueryTerpisahPerTabel from "./views/pring-gaji-query-terpisah-per-tabel";
import TestingPageBreakOk from "./views/testing-page-break-ok";
import Testing2 from "./views/testing-2";
import TestingPlayground from "./views/testing-playground";
import PrintPlainTetap from "./views/print-plain-tetap";
import JspdfPractice from "./views/jspdf-practice";
import PrintPlain from "./views/print-plain";
import PrintGaji from "./views/print-gaji";
// import ListPlt from './views/list-plt';
import CompareGajiImportExcel from "./views/compare-gaji-import-excel";
import FinalGajiListDraft from "./views/final-gaji-list-draft";
import AbsenBulanInputFinal from "./views/absen-bulan-input-final";
import IniKenapaGaBisaBatch from "./views/ini-kenapa-ga-bisa-batch";
import AbsenList from "./views/absen-list";
import PivotPractice from "./views/pivot-practice";
import GajiRekap from "./views/gaji-rekap";
import FinalGajiList from "./views/final-gaji-list";
import FinalGajiBaru from "./views/final-gaji-baru";
import AbsenBulanImport from "./views/absen-bulan-import";
import AbsenBulanInput from "./views/absen-bulan-input";
import GajiListPisahUpdated from "./views/gaji-list-pisah-updated";
import GajiBaruPisah from "./views/gaji-baru-pisah";
import SimpegPegawaiGajiImport from "./views/simpeg-pegawai-gaji-import";
import GajiListPisah from "./views/gaji-list-pisah";
import GajiListLookup from "./views/gaji-list-lookup";
import GajiList from "./views/gaji-list";
import DatagridLoadpanelPractice from "./views/datagrid-loadpanel-practice";
import GajiBaru from "./views/gaji-baru";
import FormulaBuilder from "./views/formula-builder";
import SimpegPegawaiImport2 from "./views/simpeg-pegawai-import2";
import SimpegPegawaiImport from "./views/simpeg-pegawai-import";
import SimpegDashboard from "./views/simpeg-dashboard";
import SimpegNaikPangkatList from "./views/simpeg-naik-pangkat-list";
import SimpegKgbList from "./views/simpeg-kgb-list";
import DxDateBoxFilterCell from "./views/DxDateBoxFilterCell";
import FilteringDatePractice from "./views/filtering-date-practice";
import DatagridOdataCrud from "./views/datagrid-odata-crud";
import SimpegPegawaiAdd from "./views/simpeg-pegawai-add";
import SimpegPegawaiDetail from "./views/simpeg-pegawai-detail";
import SimpegPegawaiList from "./views/simpeg-pegawai-list";
import PegawaiPensiun from "./views/pegawai-pensiun";
import KenaikanPangkat from "./views/kenaikan-pangkat";
import KenaikanGajiBerkala from "./views/kenaikan-gaji-berkala";
import RiwayatKeluarga from "./views/riwayat-keluarga";
import RiwayatPendidikan from "./views/riwayat-pendidikan";
import PegawaiRiwayat from "./views/pegawai-riwayat";
import DashboardFinal from "./views/dashboard-final";
import can from "@/haspermission";

import ResponsiveBoxPractice from "./views/responsive-box-practice";
import CardLike from "./views/card-like";
import TooltipExample from "./views/tooltip-example";
import ImageProfileChange from "./views/image-profile-change";
import ShowImagesInVue from "./views/show-images-in-vue";
import NavigationMenuEdit from "./views/navigation-menu-edit";
import NavigationMenu from "./views/navigation-menu";
import PegawaiDetailRight from "./views/pegawai-detail-right";
import DatagridDateValidation from "./views/datagrid-date-validation";
import TableGridPopup from "./views/table-grid-popup";
import PegawaiAdd from "./views/pegawai-add";
// import FormData from "./views/form-data";
import PegawaiDetail from "./views/pegawai-detail";
import PegawaiListOdataFilter from "./views/pegawai-list-odata-filter";
import PegawaiListOdataLookup from "./views/pegawai-list-odata-lookup";
import PegawaiListOdata from "./views/pegawai-list-odata";
import PegawaiList from "./views/pegawai-list-js";
import auth from "./auth";
import { createRouter, createWebHashHistory } from "vue-router";

// import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";
import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";
import plainLayout from "./layouts/plain-blank";

function loadView(view) {
  return () => import(/* webpackChunkName: "login" */ `./views/${view}.vue`);
}

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        title: "Dashboard",
      },
      component: SimpegDashboard,
    },
    {
      path: "/simpeg-dashboard",
      name: "simpeg-dashboard",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        title: "Dashboard",
      },
      component: SimpegDashboard,
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In",
      },
      component: loadView("login-form"),
    },

    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Profile,
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Tasks,
    },

    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description:
          "Masukkan email refistrasi SIMPEG, link reset password akan dikirimkan ke email tersebut.",
      },
      component: loadView("reset-password-form"),
    },

    {
      path: "/activate-user",
      name: "activate-user",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Aktivasi User",
        // description:
        //   "Please enter the email address that you used to register, and we will send you a link to reset your password via Email.",
      },
      component: loadView("activate-user-form"),
    },

    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up",
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password",
      },
      component: loadView("change-password-form"),
    },
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/recovery",
      redirect: "/home",
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home",
    },
    {
      path: "/pegawai-list-js",
      name: "pegawai-list-js",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiList,
    },
    {
      path: "/pegawai-list-odata",
      name: "pegawai-list-odata",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiListOdata,
    },
    {
      path: "/pegawai-list-odata-lookup",
      name: "pegawai-list-odata-lookup",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiListOdataLookup,
    },
    {
      path: "/pegawai-list-odata-filter",
      name: "pegawai-list-odata-filter",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiListOdataFilter,
    },
    {
      path: "/pegawai-detail",
      name: "pegawai-detail",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiDetail,
    },
    // {
    //   path: "/form-data",
    //   name: "form-data",
    //   meta: {
    //     requiresAuth: true,
    //     layout: defaultLayout,
    //   },
    //   component: FormData,
    // },
    {
      path: "/pegawai-add",
      name: "pegawai-add",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiAdd,
    },
    {
      path: "/table-grid-popup",
      name: "table-grid-popup",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: TableGridPopup,
    },
    {
      path: "/datagrid-date-validation",
      name: "datagrid-date-validation",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DatagridDateValidation,
    },
    {
      path: "/pegawai-detail-right",
      name: "pegawai-detail-right",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiDetailRight,
    },
    {
      path: "/navigation-menu",
      name: "navigation-menu",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: NavigationMenu,
    },
    {
      path: "/navigation-menu-edit",
      name: "navigation-menu-edit",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: NavigationMenuEdit,
    },
    {
      path: "/show-images-in-vue",
      name: "show-images-in-vue",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: ShowImagesInVue,
    },
    {
      path: "/image-profile-change",
      name: "image-profile-change",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: ImageProfileChange,
    },
    {
      path: "/tooltip-example",
      name: "tooltip-example",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: TooltipExample,
    },
    {
      path: "/card-like",
      name: "card-like",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: CardLike,
    },
    {
      path: "/responsive-box-practice",
      name: "responsive-box-practice",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: ResponsiveBoxPractice,
    },
    {
      path: "/dashboard-final",
      name: "dashboard-final",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DashboardFinal,
    },
    {
      path: "/pegawai-riwayat",
      name: "pegawai-riwayat",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiRiwayat,
    },
    {
      path: "/riwayat-pendidikan",
      name: "riwayat-pendidikan",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: RiwayatPendidikan,
    },
    {
      path: "/riwayat-keluarga",
      name: "riwayat-keluarga",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: RiwayatKeluarga,
    },
    {
      path: "/kenaikan-gaji-berkala",
      name: "kenaikan-gaji-berkala",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: KenaikanGajiBerkala,
    },
    {
      path: "/kenaikan-pangkat",
      name: "kenaikan-pangkat",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: KenaikanPangkat,
    },
    {
      path: "/pegawai-pensiun",
      name: "pegawai-pensiun",
      meta: {
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        layout: defaultLayout,
      },
      component: PegawaiPensiun,
    },
    {
      path: "/simpeg-pegawai-list",
      name: "simpeg-pegawai-list",
      meta: {
        title: "Daftar Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
      },
      component: SimpegPegawaiList,
    },
    {
      path: "/simpeg-pegawai-detail",
      name: "simpeg-pegawai-detail",
      meta: {
        title: "Detail Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: SimpegPegawaiDetail,
      props: true,
    },
    {
      path: "/simpeg-pegawai-add",
      name: "simpeg-pegawai-add",
      meta: {
        title: "Tambah Pegawai",
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-pegawai"],
        layout: defaultLayout,
      },
      component: SimpegPegawaiAdd,
    },
    {
      path: "/datagrid-odata-crud",
      name: "datagrid-odata-crud",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DatagridOdataCrud,
    },
    {
      path: "/filtering-date-practice",
      name: "filtering-date-practice",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: FilteringDatePractice,
    },
    {
      path: "/dx-date-box-filter-cell",
      name: "dx-date-box-filter-cell",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DxDateBoxFilterCell,
    },
    {
      path: "/simpeg-kgb-list",
      name: "simpeg-kgb-list",
      meta: {
        title: "Daftar KGB",
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji', 'staf'],
        layout: defaultLayout,
      },
      component: SimpegKgbList,
    },
    {
      path: "/simpeg-naik-pangkat-list",
      name: "simpeg-naik-pangkat-list",
      meta: {
        title: "Daftar Kenaikan Pangkat",
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        layout: defaultLayout,
      },
      component: SimpegNaikPangkatList,
    },
    {
      path: "/simpeg-dashboard",
      name: "simpeg-dashboard",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        title: "Dashboard",
      },
      component: SimpegDashboard,
    },
    {
      path: "/simpeg-pegawai-import",
      name: "simpeg-pegawai-import",
      meta: {
        requiresAuth: true,
        requiredRoles: ["superadmin"],

        layout: defaultLayout,
      },
      component: SimpegPegawaiImport,
    },
    {
      path: "/simpeg-pegawai-import2",
      name: "simpeg-pegawai-import2",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPegawaiImport2,
    },
    {
      path: "/formula-builder",
      name: "formula-builder",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: FormulaBuilder,
    },
    {
      path: "/gaji-baru",
      name: "gaji-baru",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiBaru,
    },
    {
      path: "/datagrid-loadpanel-practice",
      name: "datagrid-loadpanel-practice",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DatagridLoadpanelPractice,
    },
    {
      path: "/gaji-list",
      name: "gaji-list",
      meta: {
        title: "Daftar Gaji",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiList,
    },
    {
      path: "/gaji-list-lookup",
      name: "gaji-list-lookup",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiListLookup,
    },
    {
      path: "/gaji-list-pisah",
      name: "gaji-list-pisah",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiListPisah,
    },
    {
      path: "/simpeg-pegawai-gaji-import",
      name: "simpeg-pegawai-gaji-import",
      meta: {
        title: "Import Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPegawaiGajiImport,
    },
    {
      path: "/gaji-baru-pisah",
      name: "gaji-baru-pisah",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiBaruPisah,
    },
    {
      path: "/gaji-list-pisah-updated",
      name: "gaji-list-pisah-updated",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiListPisahUpdated,
    },
    {
      path: "/absen-bulan-input",
      name: "absen-bulan-input",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin", "staf-absensi"],
      },
      component: AbsenBulanInput,
    },
    {
      path: "/absen-bulan-import",
      name: "absen-bulan-import",
      meta: {
        title: "Import Absensi",
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-absensi"],
        layout: defaultLayout,
      },
      component: AbsenBulanImport,
    },
    {
      path: "/final-gaji-baru",
      name: "final-gaji-baru",
      meta: {
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-absensi"],
        layout: defaultLayout,
      },
      component: FinalGajiBaru,
    },
    {
      path: "/final-gaji-list",
      name: "final-gaji-list",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: FinalGajiList,
    },
    {
      path: "/gaji-rekap",
      name: "gaji-rekap",
      meta: {
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji', 'staf'],
        layout: defaultLayout,
      },
      component: GajiRekap,
    },
    {
      path: "/pivot-practice",
      name: "pivot-practice",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PivotPractice,
    },
    {
      path: "/absen-list",
      name: "absen-list",
      meta: {
        title: "Daftar Absensi",
        requiresAuth: true,
        requiredRoles: ["superadmin"],
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        layout: defaultLayout,
      },
      component: AbsenList,
    },
    {
      path: "/ini-kenapa-ga-bisa-batch",
      name: "ini-kenapa-ga-bisa-batch",
      meta: {
        title: "Daftar Absensi",
        requiresAuth: true,
        requiredRoles: ["superadmin"],
        layout: defaultLayout,
      },
      component: IniKenapaGaBisaBatch,
    },
    {
      path: "/absen-bulan-input-final",
      name: "absen-bulan-input-final",
      meta: {
        title: "Input Absensi",
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-absensi"],
        layout: defaultLayout,
      },
      component: AbsenBulanInputFinal,
    },
    {
      path: "/final-gaji-list-draft",
      name: "final-gaji-list-draft",
      meta: {
        requiresAuth: true,
        requiredRoles: [
          "superadmin",
          "admin",
          "pejabat",
          "staf-absensi",
          "staf-pegawai",
          "staf-gaji",
          "staf",
        ],
        layout: defaultLayout,
      },
      component: FinalGajiListDraft,
    },
    {
      path: "/compare-gaji-import-excel",
      name: "compare-gaji-import-excel",
      meta: {
        title: "Komparasi Gaji",
        requiresAuth: true,
        requiredRoles: ["superadmin"],
        layout: defaultLayout,
      },
      component: CompareGajiImportExcel,
    },
    // {
    //   path: "/list-plt",
    //   name: "list-plt",
    //   meta: {
    //     title: 'Daftar Riwayat PLT',
    //     requiresAuth: true,
    //     // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
    //     layout: defaultLayout
    //   },
    //   component: ListPlt
    // },
    {
      path: "/print-gaji",
      name: "print-gaji",
      meta: {
        requiresAuth: true,
        requiredRoles: [
          "superadmin",
          "admin",
          "pejabat",
          "staf-absensi",
          "staf-pegawai",
          "staf-gaji",
          "staf",
        ],
        layout: defaultLayout,
      },
      component: PrintGaji,
    },
    {
      path: "/print-plain",
      name: "print-plain",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintPlain,
    },
    {
      path: "/jspdf-practice",
      name: "jspdf-practice",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: JspdfPractice,
    },
    {
      path: "/print-plain-tetap",
      name: "print-plain-tetap",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintPlainTetap,
    },
    {
      path: "/testing-playground",
      name: "testing-playground",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: TestingPlayground,
    },
    {
      path: "/testing-2",
      name: "testing-2",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: Testing2,
    },
    {
      path: "/testing-page-break-ok",
      name: "testing-page-break-ok",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: TestingPageBreakOk,
    },
    {
      path: "/pring-gaji-query-terpisah-per-tabel",
      name: "pring-gaji-query-terpisah-per-tabel",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PringGajiQueryTerpisahPerTabel,
    },
    {
      path: "/print-gaji-tetap-ok",
      name: "print-gaji-tetap-ok",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintGajiTetapOK,
    },
    {
      path: "/print-gaji-direksi-tetap-honor-kontrak-ok",
      name: "print-gaji-direksi-tetap-honor-kontrak-ok",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintGajiDireksiTetapHonorKontrakOK,
    },
    {
      path: "/print-gaji-tetap-unit-ok",
      name: "print-gaji-tetap-unit-ok",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintGajiTetapUnitOK,
    },
    {
      path: "/print-gaji-plt",
      name: "print-gaji-plt",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: PrintGajiPlt,
    },
    {
      path: "/simpeg-pensiun-list",
      name: "simpeg-pensiun-list",
      meta: {
        title: "Daftar Pensiun",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: SimpegPensiunList,
    },
    {
      path: "/simpeg-pegawai-add-backup",
      name: "simpeg-pegawai-add-backup",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: SimpegPegawaiAddBackup,
    },
    // {
    //   path: "/simpeg-pegawai-detail-backup2",
    //   name: "simpeg-pegawai-detail-backup2",
    //   meta: {
    //     requiresAuth: true,
    //     layout: defaultLayout
    //   },
    //   component: SimpegPegawaiDetailBackup2
    // },
    {
      path: "/dxlookup-value-changed",
      name: "dxlookup-value-changed",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DxlookupValueChanged,
    },
    {
      path: "/dxlookup-value-changed-datagrid",
      name: "dxlookup-value-changed-datagrid",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DxlookupValueChangedDatagrid,
    },
    {
      path: "/practice-chart-doughnut",
      name: "practice-chart-doughnut",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PracticeChartDoughnut,
    },
    {
      path: "/practice-parent-child-template",
      name: "practice-parent-child-template",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PracticeParentChildTemplate,
    },
    {
      path: "/practice-dialog",
      name: "practice-dialog",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PracticeDialog,
    },
    {
      path: "/simpeg-kgb-prediksi-list",
      name: "simpeg-kgb-prediksi-list",
      meta: {
        title: "Daftar Prediksi KGB",
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        layout: defaultLayout,
      },
      component: SimpegKgbPrediksiList,
    },

    {
      path: "/simpeg-naikpangkat-prediksi-list",
      name: "simpeg-naikpangkat-prediksi-list",
      meta: {
        title: "Daftar Prediksi Kenaikan Pangkat",
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        layout: defaultLayout,
      },
      component: SimpegNaikpangkatPrediksiList,
    },

    {
      path: "/proyeksi-practice",
      name: "proyeksi-practice",
      meta: {
        title: "Proyeksi Gaji",
        requiresAuth: true,
        // requiredRoles: ['superadmin', 'admin', 'pejabat', 'staf-absensi', 'staf-pegawai', 'staf-gaji'],
        requiredRoles: ["superadmin"],
        layout: defaultLayout,
      },
      component: ProyeksiPractice,
    },
    {
      path: "/practice-spline-chart",
      name: "practice-spline-chart",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PracticeSplineChart,
    },
    {
      path: "/practice-loading-screen",
      name: "practice-loading-screen",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        title: "tes",
      },
      component: PracticeLoadingScreen,
    },
    {
      path: "/check-tgl-pegawai-import",
      name: "check-tgl-pegawai-import",
      meta: {
        requiresAuth: true,
        requiredRoles: ["superadmin"],
        layout: defaultLayout,
      },
      component: CheckTglPegawaiImport,
    },
    {
      path: "/gaji-periode",
      name: "gaji-periode",
      meta: {
        title: "Daftar Periode Penggajian",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiPeriode,
    },
    {
      path: "/gaji-history",
      name: "gaji-history",
      meta: {
        title: "Daftar Riwayat Gaji",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiHistory,
    },
    {
      path: "/gaji-rekap-v2",
      name: "gaji-rekap-v2",
      meta: {
        title: "Rekap Penggajian",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiRekapV2,
    },
    {
      path: "/transport-list",
      name: "transport-list",
      meta: {
        title: "Daftar Pemegang Kendaraan Dinas",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: TransportList,
    },
    {
      path: "/pendidikan-list",
      name: "pendidikan-list",
      meta: {
        title: "Daftar Riwayat Pendidikan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PendidikanList,
    },
    {
      path: "/pekerjaan-list",
      name: "pekerjaan-list",
      meta: {
        title: "Daftar Riwayat Pekerjaan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PekerjaanList,
    },
    {
      path: "/simpeg-pegawai-list-virtual-scroll",
      name: "simpeg-pegawai-list-virtual-scroll",
      meta: {
        title: "Daftar Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPegawaiListVirtualScroll,
    },
    {
      path: "/simpeg-naik-pangkat-list-virtual-scroll",
      name: "simpeg-naik-pangkat-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegNaikPangkatListVirtualScroll,
    },
    {
      path: "/simpeg-kgb-list-virtual-scroll",
      name: "simpeg-kgb-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegKgbListVirtualScroll,
    },
    {
      path: "/simpeg-kgb-prediksi-list-virtual-scroll",
      name: "simpeg-kgb-prediksi-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegKgbPrediksiListVirtualScroll,
    },
    {
      path: "/simpeg-naikpangkat-prediksi-list-virtual-scroll",
      name: "simpeg-naikpangkat-prediksi-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegNaikpangkatPrediksiListVirtualScroll,
    },
    {
      path: "/simpeg-pensiun-list-virtual-scroll",
      name: "simpeg-pensiun-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPensiunListVirtualScroll,
    },
    {
      path: "/pekerjaan-list-virtual-scroll",
      name: "pekerjaan-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: PekerjaanListVirtualScroll,
    },
    {
      path: "/list-plt-virtual-scroll",
      name: "list-plt-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: ListPltVirtualScroll,
    },
    {
      path: "/transport-list-virtual-scroll",
      name: "transport-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: TransportListVirtualScroll,
    },
    {
      path: "/pendidikan-list-virtual-scroll",
      name: "pendidikan-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: PendidikanListVirtualScroll,
    },
    {
      path: "/absen-list-virtual-scroll",
      name: "absen-list-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: AbsenListVirtualScroll,
    },
    {
      path: "/gaji-periode-virtual-scroll",
      name: "gaji-periode-virtual-scroll",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: GajiPeriodeVirtualScroll,
    },
    {
      path: "/simpeg-pegawai-list-remote",
      name: "simpeg-pegawai-list-remote",
      meta: {
        title: "REMOTE - Daftar Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPegawaiListRemote,
    },
    {
      path: "/simpeg-naik-pangkat-list-remote",
      name: "simpeg-naik-pangkat-list-remote",
      meta: {
        title: "REMOTE - Daftar Kenaikan Pangkat",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegNaikPangkatListRemote,
    },
    {
      path: "/simpeg-kgb-list-remote",
      name: "simpeg-kgb-list-remote",
      meta: {
        title: "REMOTE - Daftar KGB",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegKgbListRemote,
    },
    {
      path: "/simpeg-naikpangkat-prediksi-list-remote",
      name: "simpeg-naikpangkat-prediksi-list-remote",
      meta: {
        title: "REMOTE - Daftar Prediksi Kenaikan Pangkat",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegNaikpangkatPrediksiListRemote,
    },
    {
      path: "/simpeg-kgb-prediksi-list-remote",
      name: "simpeg-kgb-prediksi-list-remote",
      meta: {
        title: "REMOTE - Daftar Prediksi KGB",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegKgbPrediksiListRemote,
    },
    {
      path: "/simpeg-pensiun-list-remote",
      name: "simpeg-pensiun-list-remote",
      meta: {
        title: "REMOTE - Daftar Pensiun",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegPensiunListRemote,
    },
    {
      path: "/pekerjaan-list-remote",
      name: "pekerjaan-list-remote",
      meta: {
        title: "REMOTE - Daftar Riwayat Pekerjaan",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: PekerjaanListRemote,
    },
    {
      path: "/list-plt-remote",
      name: "list-plt-remote",
      meta: {
        title: "REMOTE - Daftar Riwayat PLT",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: ListPltRemote,
    },
    {
      path: "/transport-list-remote",
      name: "transport-list-remote",
      meta: {
        title: "REMOTE - Daftar Pemegang Kendaraan Dinas",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: TransportListRemote,
    },
    {
      path: "/pendidikan-list-remote",
      name: "pendidikan-list-remote",
      meta: {
        title: "REMOTE - Daftar Riwayat Pendidikan",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: PendidikanListRemote,
    },
    {
      path: "/absen-list-remote",
      name: "absen-list-remote",
      meta: {
        title: "REMOTE - Daftar Absensi",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: AbsenListRemote,
    },
    {
      path: "/absen-bulan-input-final-remote",
      name: "absen-bulan-input-final-remote",
      meta: {
        title: "REMOTE - Input Absensi",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: AbsenBulanInputFinalRemote,
    },
    {
      path: "/simpeg-dashboard-filter",
      name: "simpeg-dashboard-filter",
      meta: {
        title: "Dashboard Filter",
        requiresAuth: true,
        layout: defaultLayout,
        requiredRoles: ["superadmin"],
      },
      component: SimpegDashboardFilter,
    },

    // {
    //   path: "/absen-list-customstore",
    //   name: "absen-list-customstore",
    //   meta: {
    //     title: "CUSTOMSTORE - Daftar Absen",
    //     requiresAuth: true,
    //     layout: defaultLayout,
    //     requiredRoles: ['superadmin'],
    //   },
    //   component: AbsenListCustomstore
    // },
    {
      path: "/absen-list-custom",
      name: "absen-list-custom",
      meta: {
        title: "Daftar Absensi",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: AbsenListGabung,
    },
    {
      path: "/gaji-list-gabung",
      name: "gaji-list-gabung",
      meta: {
        title: "Daftar Gaji",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiListGabung,
    },
    {
      path: "/pegawai-list-custom",
      name: "pegawai-list-custom",
      meta: {
        title: "Daftar Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiListCustom,
    },
    {
      path: "/naik-pangkat-list-custom",
      name: "naik-pangkat-list-custom",
      meta: {
        title: "Daftar Kenaikan Pangkat",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: NaikPangkatListCustom,
    },
    {
      path: "/kgb-list-custom",
      name: "kgb-list-custom",
      meta: {
        title: "Daftar KGB",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: KgbListCustom,
    },
    {
      path: "/pekerjaan-list-custom",
      name: "pekerjaan-list-custom",
      meta: {
        title: "Daftar Riwayat Pekerjaan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PekerjaanListCustom,
    },
    {
      path: "/transport-list-custom",
      name: "transport-list-custom",
      meta: {
        title: "Daftar Pemegang Kendaraan Dinas",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: TransportListCustom,
    },
    {
      path: "/pendidikan-list-custom",
      name: "pendidikan-list-custom",
      meta: {
        title: "Daftar Riwayat Pendidikan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PendidikanListCustom,
    },
    {
      path: "/naik-pangkat-prediksi-list-custom",
      name: "naik-pangkat-prediksi-list-custom",
      meta: {
        title: "Daftar Prediksi Kenaikan Pangkat",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: NaikPangkatPrediksiListCustom,
    },
    {
      path: "/kgb-prediksi-list-custom",
      name: "kgb-prediksi-list-custom",
      meta: {
        title: "Daftar Prediksi KGB",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: KgbPrediksiListCustom,
    },
    {
      path: "/pensiun-list-custom",
      name: "pensiun-list-custom",
      meta: {
        title: "Daftar Pensiun",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PensiunListCustom,
    },
    {
      path: "/absen-list-custom",
      name: "absen-list-custom",
      meta: {
        title: "Daftar Absensi",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: AbsenListCustom,
    },
    {
      path: "/absen-input-custom",
      name: "absen-input-custom",
      meta: {
        title: "Input Absensi",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: AbsenInputCustom,
    },
    {
      path: "/pegawai-detail-custom",
      name: "pegawai-detail-custom",
      meta: {
        title: "Detail Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PegawaiDetailCustom,
    },

    {
      path: "/belajar-tagbox",
      name: "belajar-tagbox",
      meta: {
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: BelajarTagbox,
    },
    {
      path: "/arsip-list",
      name: "arsip-list",
      meta: {
        title: "Daftar Arsip",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: ArsipList,
    },
    {
      path: "/pengajuan-list",
      name: "pengajuan-list",
      meta: {
        title: "Daftar Pengajuan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PengajuanList,
    },
    {
      path: "/gaji-list-custom",
      name: "gaji-list-custom",
      meta: {
        title: "Daftar Gaji",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiListCustom,
    },
    {
      path: "/gaji-print",
      name: "gaji-print",
      meta: {
        title: "Print Gaji",
        requiresAuth: true,
        layout: plainLayout,
        // layout: defaultLayout
      },
      component: GajiPrint,
    },
    {
      path: "/gaji-rekap-print",
      name: "gaji-rekap-print",
      meta: {
        title: "Print Rekap Gaji",
        requiresAuth: true,
        layout: plainLayout,
      },
      component: GajiRekapPrint,
    },
    {
      path: "/gaji-history-custom",
      name: "gaji-history-custom",
      meta: {
        title: "Daftar Riwayat Gaji",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: GajiHistoryCustom,
    },
    // {
    //   path: "/absen-list-input",
    //   name: "absen-list-input",
    //   meta: {
    //     title: 'Input Absensi',
    //     requiresAuth: true,
    //     layout: defaultLayout
    //   },
    //   component: AbsenListInput
    // },
    {
      path: "/peringatan-list",
      name: "peringatan-list",
      meta: {
        title: "Daftar Riwayat Peringatan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PeringatanList,
    },
    {
      path: "/penghargaan-list",
      name: "penghargaan-list",
      meta: {
        title: "Daftar Riwayat Penghargaan",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: PenghargaanList,
    },

    {
      path: "/dewas-detail",
      name: "dewas-detail",
      meta: {
        title: "Detail Dewan Pengawas",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DewasDetail,
    },
    {
      path: "/dewas-list",
      name: "dewas-list",
      meta: {
        title: "Daftar Dewan Pengawas",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DewasList,
    },
    {
      path: "/dewas-add",
      name: "dewas-add",
      meta: {
        title: "Tambah Dewan Pengawas",
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-pegawai"],
        layout: defaultLayout,
      },
      component: DewasAdd,
    },
    {
      path: "/dewas-arsip",
      name: "dewas-arsip",
      meta: {
        title: "Daftar Arsip Dewan Pengawas",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DewasArsip,
    },
    {
      path: "/diklat-list",
      name: "diklat-list",
      meta: {
        title: "Daftar Diklat",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DiklatList,
    },
    {
      path: "/diklat-print",
      name: "diklat-print",
      meta: {
        title: "Print Diklat",
        requiresAuth: true,
        layout: plainLayout,
      },
      component: DiklatPrint,
    },
    {
      path: "/html-to-word-practice",
      name: "html-to-word-practice",
      meta: {
        requiresAuth: true,
        layout: plainLayout,
      },
      component: HtmlToWordPractice,
    },
    {
      path: "/generate-document",
      name: "generate-document",
      meta: {
        title: "Generate Dokumen",
        requiresAuth: true,
        requiredRoles: ["superadmin", "admin", "staf-pegawai", "pejabat"],
        layout: defaultLayout,
      },
      component: GenerateDocument,
    },
    {
      path: "/diklat-print-page-break",
      name: "diklat-print-page-break",
      meta: {
        title: "Print Diklat",
        requiresAuth: true,
        layout: plainLayout,
      },
      component: DiklatPrintPageBreak,
    },
    {
      path: "/skema-gaji-list",
      name: "skema-gaji-list",
      meta: {
        title: "Daftar Skema Penggajian",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: SkemaGajiList,
    },
    {
      path: "/duk-list",
      name: "duk-list",
      meta: {
        title: "DUK",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: DukList,
    },
    {
      path: "/duk-print",
      name: "duk-print",
      meta: {
        title: "Print DUK",
        requiresAuth: true,
        layout: plainLayout,
      },
      component: DukPrint,
    },

    {
      path: "/cek-gaji",
      name: "cek-gaji",
      meta: {
        title: "Cek Gaji Per Pegawai",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: CekGaji,
    },

    {
      path: "/activity-log",
      name: "activity-log",
      meta: {
        title: "Activity Log",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: ActivityLog,
    },
    {
      path: "/cuti-setting-list",
      name: "cuti-setting-list",
      meta: {
        title: "Pengaturan Cuti",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: CutiSettingList,
    },
    {
      path: "/cuti-list",
      name: "cuti-list",
      meta: {
        title: "Daftar Cuti",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: CutiList,
    },
    {
      path: "/libur-list",
      name: "libur-list",
      meta: {
        title: "Daftar Hari Libur",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: LiburList,
    },
    {
      path: "/dp3-list",
      name: "dp3-list",
      meta: {
        title: "Daftar DP3",
        requiresAuth: true,
        layout: defaultLayout,
      },
      component: Dp3List,
    },
    {
      path: "/user-list",
      name: "user-list",
      meta: {
        title: "Daftar User",
        requiresAuth: true,
        requiredRoles: ["superadmin"],
        layout: defaultLayout,
      },
      component: UserList,
    },
  ],
  history: createWebHashHistory(),
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || "SIMPEG Tirta Hita";
  var isLoggedIn = await auth.loggedIn();

  var userRole = auth.getUserRole();
  // var userPermission = auth.getUserPermission();

  if (
    (to.name === "login-form" ||
      to.name === "activate-user" ||
      to.name === "reset-password") &&
    isLoggedIn
  ) {
    next({ name: "home" });
    // nanti diperbaiki
  }

  // if (to.matched.some(record => record.meta.requiresAuth)) {
  //   if (!isLoggedIn) {
  //     next({
  //       name: "login-form",
  //       query: { redirect: to.fullPath }
  //     });
  //   } else {
  //     // If the route requires certain roles
  //     if (to.matched.some(record => record.meta.requiredRoles)) {
  //       // Check if user has necessary role
  //       if (to.matched.some(record => record.meta.requiredRoles.includes(userRole.name))) {
  //         // console.log("router", "role masuk")
  //         console.log("router", to, can('gaji-show'));
  //         if (to.name === 'gaji-periode' && !can('gaji-show')) {
  //           next({ name: 'home' }); // Redirect to home or dashboard
  //       }else{
  //         next();
  //       }

  //       } else {
  //         next({name: "home"}); // Redirect to home or any other page
  //       }
  //     } else {
  //       next();
  //     }
  //     // next();
  //   }
  // } else {
  //   next();
  // }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath },
      });
    } else {
      // If the route requires certain roles
      if (to.matched.some((record) => record.meta.requiredRoles)) {
        // Check if user has the necessary role
        if (
          to.matched.some((record) =>
            record.meta.requiredRoles.includes(userRole.name),
          )
        ) {
          // Check if the route is 'gaji-periode' and if the user has the 'gaji-show' permission
          if (to.name.includes("gaji") && !can("gaji-show")) {
            next({ name: "home" }); // Redirect to home or dashboard
          } else if (to.name.includes("absen") && !can("absensi-show")) {
            next({ name: "home" }); // Redirect to home or dashboard
          } else if (to.name.includes("proyeksi") && !can("superadmin")) {
            next({ name: "home" }); // Redirect to home or dashboard
          } else {
            next(); // User has the role and the permission, allow access
          }
        } else {
          next({ name: "home" }); // Redirect to home or any other page if role check fails
        }
      } else {
        // If no specific role is required, just check permissions for 'gaji-periode'
        if (to.name.includes("gaji") && !can("gaji-show")) {
          next({ name: "home" }); // Redirect to home or dashboard
        } else if (to.name.includes("absen") && !can("absensi-show")) {
          next({ name: "home" }); // Redirect to home or dashboard
        } else if (to.name.includes("proyeksi") && !can("superadmin")) {
          next({ name: "home" }); // Redirect to home or dashboard
        } else {
          next(); // No specific role required and user has necessary permissions
        }
      }
    }
  } else {
    next(); // Route does not require authentication
  }
});
router.afterEach(async (to) => {
  try {
    await api.post("/log-visit", { url: to.fullPath });
  } catch (error) {
    console.error("Log visit failed:", error);
    throw error;
  }
});
export default router;
